// @ts-check

import "../jsdoc-types"
import { Typography } from "@bonprix/design-system";

/**
 * @param {Object} props
 * @param {ImageTeaserEntry} props.cdaEntry
 */
export function ImageTeaser({ cdaEntry }) {
    const textColor = cdaEntry.fields.textColor || "white";

    return (
        <div className="service-page-image-teaser">
            <img
                src={cdaEntry.fields.image?.fields.file.url}
                alt={cdaEntry.fields.image?.fields.description}
            />

            <div
                className="service-page-image-teaser__text"
                style={{
                    color: textColor,
                }}
            >
                <Typography variant="bonprix-h1" component={cdaEntry.fields.isH1 ? "h1" : "p"}>
                    {cdaEntry.fields.text}
                </Typography>
            </div>
        </div>
    );
}
